import * as React from "react";
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";
import OutlineButton from "app/common/components/featureButton/preset/outlineButton";
import OverlayTooltip from "common/components/overlayTooltip";
import { FormattedMessage } from "react-intl";

const styles = require("./writeCard.scss");

interface IProps {
  width: number;
  height: number;
  onClick?: () => void;
}

const WriteCardButton: React.FC<IProps> = ({ width, height, onClick }) => {
  const [hoverState, setHoverState] = React.useState(false);
  const handleHover = React.useCallback(setHoverState, []);

  const changeableIcon = hoverState
    ? PACKS.ENGAGE.ANSWER_HOVER
    : PACKS.ENGAGE.ANSWER_NORMAL;

  return (
    <OverlayTooltip
      position="right"
      tooltipContent={<FormattedMessage id="write_answer" />}
    >
      <OutlineButton
        width={width}
        height={height}
        onClick={onClick}
        onHover={handleHover}
      >
        <span className={styles.iconWrapper}>
          <IconWrapper
            tagName="span"
            icon={changeableIcon}
            className={styles.icon}
          />
        </span>
      </OutlineButton>
    </OverlayTooltip>
  );
};

export default WriteCardButton;
